import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import { Select, Spin } from 'antd';
import * as api from './api';

const UserSelector = ({ forwardedRef, ...rest }) => {
  const [userSelectOptions, setUserSelectOptions] = useState([]);
  const [findUserState, setFindUserState] = useState(false);
  const findUser = useMemo(() => {
    const loadOptions = phone => {
      if (phone.length < 10) return;
      setFindUserState(true);
      api
        .findUser({ phone })
        .then(({ data }) => {
          let options = data || [];
          options = Array.isArray(options) ? options : [options];
          setUserSelectOptions(options);
        })
        .finally(() => setFindUserState(false));
    };
    return debounce(loadOptions, 800);
  }, []);

  return (
    <Select
      ref={forwardedRef}
      showSearch
      placeholder="输入手机号搜索"
      filterOption={false}
      optionFilterProp="phone"
      notFoundContent={findUserState ? <Spin size="small" /> : null}
      onSearch={findUser}
      {...rest}
    >
      {userSelectOptions.map((user, index) => (
        <Select.Option key={index} value={user.accountId} label={user.phone}>
          {user.userName}
        </Select.Option>
      ))}
    </Select>
  );
};
UserSelector.propTypes = { forwardedRef: PropTypes.any };

export default React.forwardRef((props, ref) => (
  <UserSelector forwardedRef={ref} {...props} />
));
